import { Radio, Lock, Crown } from 'lucide-react';

export function EventCard({ event, isSelected, onSelect }) {
  const isLocked = event.locked;
  
  return (
    <div 
      onClick={() => {
        if (!isLocked) {
          onSelect(event);
        }
      }}
      className={`glass-card p-4 cursor-pointer border-2 transition-all ${
        isSelected 
          ? 'border-red-500 neon-glow' 
          : isLocked 
          ? 'border-white/10 opacity-60' 
          : 'border-white/10 hover:border-red-500/50'
      }`}
      data-testid={`live-event-${event.id}`}
    >
      <div className="flex gap-4">
        <div className="relative w-32 h-20 flex-shrink-0">
          <img 
            src={event.thumbnail_url} 
            alt={event.title}
            className="w-full h-full object-cover rounded-lg"
          />
          {isLocked && (
            <div className="absolute inset-0 flex items-center justify-center bg-black/60 rounded-lg">
              <Lock className="w-6 h-6 text-yellow-400" />
            </div>
          )}
          {event.is_live && (
            <div className="absolute top-1 left-1 px-2 py-0.5 bg-red-500 rounded text-xs font-bold flex items-center gap-1">
              <Radio className="w-3 h-3" /> LIVE
            </div>
          )}
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold truncate">{event.title}</h3>
          <p className="text-sm text-gray-400 line-clamp-2">{event.description}</p>
          {event.is_premium && (
            <span className="inline-flex items-center gap-1 text-xs text-yellow-400 mt-1">
              <Crown className="w-3 h-3" /> Premium Only
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
